interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  kicker,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div className={`flex flex-col ${isCenter ? "items-center text-center" : "items-start text-left"}`}>
      {kicker ? (
        <span className="mb-3 font-label text-xs uppercase tracking-[0.35em] text-primary-600">
          {kicker}
        </span>
      ) : null}
      <h2 className="font-heading text-2xl leading-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      <span className="mt-5 block h-px w-14 bg-primary-500" />
      {description ? (
        <p className={`mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${isCenter ? "mx-auto" : ""}`}>
          {description}
        </p>
      ) : null}
    </div>
  );
}